import React, {useState} from 'react'
import UserPackagePopup from "./UserPackagePopup";

const BoxItem4 = (props) => {
    const {title, number} = props
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <div className="BoxItem PageHeading">
        <div className="d-flex justify-content-between w-100">
            <div className="Title">
                <div className="Name">{title}</div>
                <div className="Number">{number ? `Gói ${number}` : 'N/A'}</div>
            </div>
            <button onClick={_toggleModal} className="ButtonCustom">Xem gói</button>
            {showModal && <UserPackagePopup showModal={showModal} toggleModal={_toggleModal}/>}
        </div>
    </div>
}

export default BoxItem4
